import 'regenerator-runtime/runtime';
export { i as default } from './onboard-ad4c8a7c.js';
import 'bignumber.js';
import 'bnc-sdk';
import 'bowser';